export default "__VITE_ASSET__a3a3ed30__"